import { observable, action } from 'mobx';
import { setFilterState } from '../itemlist';

// Itemlist Store
export default class ItemlistStore {
  @observable html = '';
  @observable preview = '';
  @observable url = null;
  update(data) {
    if (data.preview !== undefined) {
      this.preview = data.preview;
    }
    if (data.html !== undefined) {
      this.html = data.html;
    } else if ((typeof data) === 'string') {
      this.html = data;
    }
  }

  @action
  filter(url, setState = true, postData = undefined) {
    this.url = url;
    const $itemlist = $('[data-itemlist]');
    $itemlist.addClass('mask mask--light');
    const currentUrl = new URL(window.location);
    if (setState) {
      if (!$itemlist.is('[data-no-state]')) {
        if ($itemlist.is('[data-push-state]')) {
          window.history.pushState(null, null, url);
        } else {
          window.history.replaceState(null, null, url);
        }
      }
      $('[data-lang-link]').each(function () {
        if (!$(this).data('original')) {
          $(this).data('original', $(this).attr('href'));
        }
        if (url.includes('?')) {
          $(this).attr('href', `${$(this).data('original').split('?')[0]}?${url.split('?')[1]}`);
        } else {
          $(this).attr('href', $(this).data('original').split('?')[0]);
        }
      });
    }

    // add a suffix to the url to prevent caching the json-content in browser history for the url
    let suffix = '';
    if (!url.includes('_ajax')) {
      if (url.includes('?')) {
        suffix = '&_ajax=1';
      } else {
        suffix = '?_ajax=1';
      }
    }
    return $.ajax({
      url: `${url}${suffix}`,
      method: postData ? 'POST' : 'GET',
      data: postData,
      success: (data) => {
        if (url === this.url) {
          this.update(data);
          $itemlist.removeClass('mask mask--light');
        }
        setFilterState(currentUrl);
      },
      error: () => {
        $itemlist.removeClass('mask mask--light');
      },
    });
  }
}
